import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  mainContainer: {
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
  itemContainer: {
    marginTop: 12,
  },
  buttonContainer: {
    marginTop: 15,
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    color: '#000A8C',
    border: '2px solid #000A8C',
    paddingLeft: 20,
    paddingRight: 20,
    textTransform: 'none',
    '@media only screen and (max-width: 600px)': {
      display: 'none',
    },
    '@media only screen and (max-width: 391px)': {
      display: 'none',
    },
  },
  separator: {
    border: 'none',
    borderTop: '1px solid #D4D4D8',
    margin: '25px 0 30px 0',
    width: '100%',
  },
  responsetitle: {
    fontFamily: 'Poppins',
    fontSize: 18,
    fontWeight: 700,
    color: '#23296F',
    marginTop: 10,
    textAlign: 'center',
  },
  responsesContainer: {
    width: '100%',
    maxWidth: '100%',
  },
  responseTypeContainer: {
    marginTop: 15,
    marginBottom: 15,
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
    '& .MuiFormControl-root': {
      alignItems: 'flex-start',
      textAlign: 'left',
      justifyContent: 'flex-start',
      width: 'auto',
    },
  },
  responseTypeTitle: {
    fontFamily: 'Poppins',
    fontSize: 14,
    fontWeight: 700,
    color: '#0E1247',
  },
  radioGroup: {
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'row',
    '& .MuiFormControlLabel-root': {
      marginRight: 30,
      marginLeft: 0,
    },
  },
  radioButton: {
    '& .MuiFormControlLabel-label': {
      fontFamily: 'Poppins',
      fontSize: 14,
      fontWeight: 400,
      color: '#23296F',
    },
    '& .MuiRadio-root': {
      color: '#000a8c',
      padding: '6px',
      '& .MuiSvgIcon-root': {
        fontSize: '1.2rem',
      },
      '&.Mui-checked': {
        color: '#000a8c',
      },
    },
  },
}));
